import React from 'react'
import { Link } from 'gatsby'
import phoneLogo from '../img/logo.png'
import { useMediaQuery } from 'react-responsive'

const Navbar = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  return (
    <nav
      className="navbar is-transparent"
      role="navigation"
      aria-label="main-navigation"
    >
      <div className="header-wrapper">
        <div className={`header-wrapper-inner ${isMobile ? "" : "horizontal-card-slider"}`}>
          <Link to="/">
            <img
              src={phoneLogo}
              alt="phone-logo"
              style={{
                height: 65,
                borderRadius: 1000,
                width: 'auto',
                background:'#ffffff',
              }}
            />
          </Link>
          <p className="logo-label">
            onecard.bio
          </p>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
